import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62fe346e&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=62fe346e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fe346e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62fe346e')) {
      api.createRecord('62fe346e', component.options)
    } else {
      api.reload('62fe346e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62fe346e&scoped=true&", function () {
      api.rerender('62fe346e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/footer/index.vue"
export default component.exports